import * as angular from 'angular';
import * as $ from 'jquery';

import { ReportDataService } from '../../services/report-data-service';
import { SaveAlertModalController } from './save-alert-modal-controller';
import template from './save-alert-modal.html';

const saveAlertModalDirective = function (Modal, reportDataService: ReportDataService, ReportSaveService) {
  return {
    restrict: 'A',
    scope: {
      report: '<',
    },
    link: function ($scope: angular.IScope, elem, attrs) {
      elem.on('click.saveReportAlertModal', (event) => {
        if (!ReportSaveService.reportHasChanged()) {
          return;
        }
        event.preventDefault();
        event.stopPropagation();

        const modal = Modal.open(
          {
            url: $scope.report.share,
          },
          {
            template: template,
            controller: SaveAlertModalController,
            controllerAs: 'ctrl',
            bindToController: true,
          }
        );
        modal.result.then((r) => {
          reportDataService.updateReportWithAlertAndRefreshPreview();
        });
      });

      // cleanup handlers
      $scope.$on('$destroy', () => elem.off('click.saveReportAlertModal'));
    },
  };
};

saveAlertModalDirective.$inject = ['ModalService', 'ReportDataService', 'ReportSaveService'];

angular.module('mode.components').directive('saveReportAlert', saveAlertModalDirective);
